"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _phoneValidation = require("../global/utils/phoneValidation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules
// Utils
var ContactPracticeMessage = function ContactPracticeMessage(props) {
  var name = props.name,
      phone = props.phone;
  return /*#__PURE__*/_react.default.createElement("p", null, "Please contact ", name, " at", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+1".concat(phone)
  }, (0, _phoneValidation.formatPhone)(phone)), " to pay your outstanding balance.");
};

var _default = ContactPracticeMessage;
exports.default = _default;